import { trackAction } from '../../../../../../libs/analytics/ActionTracking';
import { UploadType } from '../../../../../../consts/uploadType';
import { Customer, Site } from '../../../../../../types';

const oldMetricNames = {
  [UploadType.RegularAndRtk]: 'scan',
  [UploadType.Ppk]: 'ppk',
  [UploadType.Lidar]: 'lidar',
  [UploadType.Pano]: 'pano',
};

export const trackUpload = (uploadType: UploadType, customer: Customer, site: Site) => {
  const metricName = oldMetricNames[uploadType];

  trackAction(`Click to select ${metricName} photos`, { customer, site });
};
